import React from 'react';
import { isAuthenticated } from '../../../../utils/session-util';
import { Redirect, Route } from 'react-router-dom';
import { HOME_URL } from '../../../../route-names';

const UnauthedRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      !isAuthenticated() ? <Component {...props} /> : <Redirect to={HOME_URL} />
    }
  />
);

export default UnauthedRoute;
